//
// Module for the partner sites Index view
//
rs.module("content/system/configuration/partnersites/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrls) {

            var filter = $.js(jsSelectors.filter);
            var applicationSelect = filter.js(jsSelectors.applicationSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);
            var addLink = $.js(jsSelectors.addLink);

            // Hook up change event on applicationSelect to reload the grid data via ajax
            applicationSelect.on('change', function () {

                loadingSpinner.show();

                gridModule.update(

                    ajaxUrls.getGridData,
                    { applicationId: this.value },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();

                        $.get(ajaxUrls.getAddLink, {
                            applicationId: applicationSelect.val()
                        }).done(function (result) {
                            addLink.prop("href", result.url);
                        });
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);